import { createServerFn } from '@tanstack/react-start';
import { fetchQuery, graphql } from 'react-relay';

import type { getDirectoryAreasQuery } from '@/pages/directory/utils/__generated__/getDirectoryAreasQuery.graphql';
import { getRelayEnvironment } from '@/relay/environment';

export type DirectoryAreaListing = {
  listedAgentCount: number;
  name: string;
  slug: string;
  updatedAt: string;
};

export const getDirectoryAreas = createServerFn({ method: 'GET' }).handler(
  async (): Promise<DirectoryAreaListing[]> => {
    const { environment } = getRelayEnvironment();
    const result = await fetchQuery<getDirectoryAreasQuery>(
      environment,
      graphql`
        query getDirectoryAreasQuery {
          landlordDirectoryAreas {
            listedAgentCount
            name
            slug
            updatedAt
          }
        }
      `,
      {},
    ).toPromise();

    return (
      result?.landlordDirectoryAreas?.flatMap((area) => {
        if (
          !area?.slug ||
          !area.name ||
          area.listedAgentCount == null ||
          !area.updatedAt
        ) {
          return [];
        }

        return [
          {
            listedAgentCount: area.listedAgentCount,
            name: area.name,
            slug: area.slug,
            updatedAt: area.updatedAt,
          },
        ];
      }) ?? []
    );
  },
);
